export default __webpack_public_path__ + "static/media/mypage_banner.1cd56b46.png";